import { useQuery } from '@tanstack/react-query'
import { hasInternalApi, internalApiGet } from './internalApi'
import { supabase, type Manager } from './supabase'

type ManagersResponse = {
  managers: Manager[]
}

/**
 * Fetches all managers (the people who can be assigned to livers).
 * Used by the assignment-change modal as the new-owner picker.
 */
export function useManagers() {
  return useQuery<Manager[]>({
    queryKey: ['managers'],
    queryFn: async () => {
      if (hasInternalApi()) {
        const response = await internalApiGet<ManagersResponse>('/api/managers')
        return response.managers
      }

      const { data, error } = await supabase
        .from('managers')
        .select('*')
        .is('left_at', null) // exclude already-departed managers
        .order('name', { ascending: true, nullsFirst: false })
      if (error) throw error
      return (data ?? []) as Manager[]
    }
  })
}
